(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/common/assets/javascripts/helpers.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/common/assets/javascripts/helpers.js');
"use strict";


const {
  BrowserStorageConstants
} = svs.poker_react.components.common.constants;
const isMobile = svs.core.detect.formfactor.mobile();
const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
const {
  constants: {
    EXPIRES_10M
  },
  browser: BrowserStorage
} = svs.components.Storage;
const pokerHome = svs.core.urlMapping.get('pokerHome');
const trackPokerPlayEvent = tournamentName => {
  const trackingLabel = tournamentName !== null && tournamentName !== void 0 ? tournamentName : 'SPELA DIREKT';
  svs.components.analytics.trackEvent({
    category: 'Poker',
    action: tournamentName ? 'Upcoming events' : 'initiate poker',
    opt_label: trackingLabel
  });
};

const launchWebClient = function () {
  let {
    tournamentId,
    tournamentName,
    shouldTrackEvent = true
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (shouldTrackEvent) {
    trackPokerPlayEvent(tournamentName);
  }
  if (!isLoggedIn) {
    BrowserStorage.set(BrowserStorageConstants.OpenWebClientKey, BrowserStorageConstants.Domain, {
      openWebClient: true,
      params: {
        tournamentId
      }
    }, EXPIRES_10M, () => {
      svs.components.customer_login.login();
    });
  } else {
    const qs = new URLSearchParams();
    qs.append('formFactor', isMobile ? 'mobile' : 'desktop');
    if (tournamentId) {
      qs.append('tournamentId', tournamentId);
    }
    window.open("".concat(pokerHome, "/spela?").concat(qs.toString()), '', 'popup=true,width=1280,height=720');
  }
};

const handleDownloadClick = (device, url) => {
  svs.components.analytics.trackEvent({
    category: 'Poker',
    action: 'Download client',
    opt_label: device
  });
  location.href = url;
};
const helpers = {
  launchWebClient,
  trackPokerPlayEvent,
  handleDownloadClick
};
setGlobal('svs.poker_react.components.common.helpers', helpers);

 })(window);